export function returnToAdminPanel(): void {
  window.location.href = '/admin';
}
